import * as React from "react";
import { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgHomeAdd = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" width="1em" height="1em" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M26.002 12.603V3.88h-4v4.849L16 2.908 0 18.423v.97h4v9.699h24v-9.699h4v-.97zM21.06 19.55h-3.872v3.853h-2.19V19.55h-3.873v-2.19h3.873v-3.901h2.19v3.9h3.872z" /></svg>;
export default SvgHomeAdd;